import { render } from "./ZonePricingForCustomerAddOrUpdateTable.html?vue&type=template&id=6147e86a&scoped=true"
import script from "./ZonePricingForCustomerAddOrUpdateTable.js?vue&type=script&lang=js"
export * from "./ZonePricingForCustomerAddOrUpdateTable.js?vue&type=script&lang=js"

import "./ZonePricingForCustomerAddOrUpdateTable.css?vue&type=style&index=0&id=6147e86a&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6147e86a"]])

export default __exports__